<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="loadData(1)">刷新</el-button>
            </div>
            <div class="header-right"></div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号" width="70">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="downloadName" label="任务名称"></el-table-column>
            <el-table-column prop="productCount" label="任务状态">
                <template slot-scope="scope">
                    <el-tag>{{ getDownloadStatusName(scope.row.downloadStatus) }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="downloadProductCount" label="钱币数量"></el-table-column>
            <el-table-column prop="downloadImageCount" label="图片数量"></el-table-column>
            <el-table-column prop="downloadZipSize" label="文件大小"></el-table-column>
            <el-table-column label="创建时间">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.downloadDateCreate) }}
                </template>
            </el-table-column>
            <el-table-column label="完成时间">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.downloadDateFinish) }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="250">
                <template slot-scope="scope">
                    <el-button @click="downloadZip(scope.row.downloadZip)" type="text" size="small" v-if="scope.row.downloadStatus == 2">下载</el-button>
                    <el-button @click="handleClick('update', scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="handleClick('delete', scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40, 100, 500]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="30%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="110px">
                    <el-form-item label="任务名称">
                        <el-input v-model="handleInfo.downloadName"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"
import enumMixin from "@/mixins/enum-mixin.js"

export default {
    mixins: [verifyMixin, listMixin, enumMixin],
    data: function () {
        return {
        }
    },
    methods: {
        downloadZip: function(zipFile) {
            window.open(process.env.VUE_APP_FILE + "coinv3/zip/" + zipFile);
        }
    },
    created: async function () {
        this.tag = "DOWNLOAD";
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
</style>